import { theme } from '@theme';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PortfolioFilterType } from '../../../../../enums/PortfolioFilterType';
import { usePortfolioFilter } from '../../../../../hooks/UsePortfolioFilter';
import { AppState } from '../../../../../store/AppState';
import { setOpenFilterCount } from '../../../../../store/portfolio/PortfolioActions';
import { PortfolioState } from '../../../../../store/portfolio/PortfolioReducer';
import MultiSelectDropdown from '../../../../shared/filters/multi-select-dropdown/MultiSelectDropdown';
import { Typography } from '../../../../style';

const PortfolioAssigneeFilter: FC = () => {
  const { dealType, openFilterCount } = useSelector<AppState, PortfolioState>(
    (state) => state.portfolio,
  );
  const { setSelectedFilter, getPortfolioView, getSelectionToggleType } = usePortfolioFilter();
  const currentView = getPortfolioView(dealType);
  const dispatch = useDispatch();

  const onOpen = () => {
    const newOpenFilterCount = openFilterCount + 1;
    dispatch(setOpenFilterCount(newOpenFilterCount));
  };
  const onClose = () => {
    const newOpenFilterCount = openFilterCount === 0 ? 0 : openFilterCount - 1;
    dispatch(setOpenFilterCount(newOpenFilterCount));
  };

  const label: string = currentView?.selectedFilters.assignees?.length
    ? currentView?.selectedFilters.assignees?.length > 1
      ? `${currentView?.selectedFilters.assignees?.length} Selected`
      : currentView?.selectedFilters.assignees[0].label
    : `All`;

  const getSubLabel = (): JSX.Element => {
    return (
      <Typography
        className='text-capitalize'
        data-testid='dropdown-select-bottom-label'
        size={theme.typography.h5}
        color={theme.palette.white}
      >
        {label}
      </Typography>
    );
  };

  return (
    <div data-testid='portfolio-assignee-filter'>
      <MultiSelectDropdown
        placeholder={'Assignee'}
        displaySelectedLabels={true}
        options={currentView?.filters.assignees}
        onChange={(value) => setSelectedFilter(PortfolioFilterType.Assignee, value, dealType)}
        onUpdate={(values) =>
          setSelectedFilter(PortfolioFilterType.Assignee, values, dealType, false)
        }
        values={currentView?.selectedFilters.assignees}
        allowSearchFilter={true}
        displaySubLabel={getSubLabel()}
        onOpen={onOpen}
        onClose={onClose}
        enableCheckAll={true}
        type='am-label'
        cssClass='exclude-sorting'
        dynamicRender={false}
        selectionToggleType={getSelectionToggleType(
          PortfolioFilterType.Assignee,
          dealType,
          currentView?.selectedFilters.assignees,
        )}
      />
    </div>
  );
};

export default PortfolioAssigneeFilter;
